import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function getRoundMatches(league_pk, round_pk) {
  const token = Cookies.getToken();

  try {
    const res = await axios({
      method: 'GET',
      url:
        process.env.REACT_APP_API_URL +
        `/api/league/leagues/${league_pk}/rounds/${round_pk}/matches/`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    return { error: error };
  }
}

